<div id="layoutHome" class="web-center">
    <div class="col-md-12 adaptiveImgHeight">
        
            <img class="w-100" src="assets/images/Header_Blog.png" style="height: 100%; width: 100%; object-fit: cover;" />
        
        <div class="overlay-banner-Tablet"></div>
    </div>
    <div class="menu-container no-scrollbar">
        <ul class="menu-list" [class]="isMobile ? '' : 'justify-content-center'">
            <li *ngFor="let item of tabItems" class="mb-2 mt-2 p-2" style="cursor: pointer; list-style-type: none;">
                <button 
                    [style.background-color]="selectedMasterTab === item ? '#dfdfef' : '#f9f9fb'"
                    (click)="filterBlogs(item)" class="btn btn-primary mt-2 mx-1 categoriesButton tab-item">
                    {{ item }}
                </button>
            </li>
        </ul>
    </div>
    <div class="mt-3 mb-5 d-flex flex-wrap justify-content-center" style="min-height: 415px; width: 80%; gap: 20px;">
        <ng-container *ngFor="let item of blogsModel">
            <ng-container *ngTemplateOutlet="
                    listCards;
                    context: { $implicit: item }
                ">
            </ng-container>
        </ng-container>
    </div>
    <div class="blog-bottom-box">
        <svg xmlns="http://www.w3.org/2000/svg" width="219" height="93" viewBox="0 0 219 93" fill="none">
            <path d="M218.5 1L134.589 28.7137C118.296 34.095 100.704 34.095 84.411 28.7137L0.499997 1.00002" stroke="#EF870A"/>
            <path d="M218.5 29L134.589 56.7137C118.296 62.095 100.704 62.095 84.411 56.7137L0.499997 29" stroke="#EF870A"/>
            <path d="M218.5 57L134.589 84.7137C118.296 90.095 100.704 90.095 84.411 84.7137L0.499997 57" stroke="#EF870A"/>
        </svg>
        <div style="width: 100%; height: 100%; border-radius: 200px; backdrop-filter: blur(2px); flex-direction: column; justify-content: center; align-items: center; gap: 20px; display: inline-flex">
            <div class="hungry-for-more">Hungry for more?</div>
            <div class="punchline">Get the exclusive offer</div>
        </div>
        
    </div>
    <div style="margin-top: 48px; margin-bottom:75px">
        <app-offer-banner [sticky]="false" link="/order-flow"/>
    </div>
</div>

<ng-template #listCards let-item>
    <div class="mb-4 position-relative responsiveFont fm-rubik" [class]="isDesktop ? 'col-md-6' : isTablet ? 'col-md-6' : 'col-md-12'" [style]="isDesktop ? 'width:351px' :  isTablet ? 'width:351px' : 'width:361px'" (mouseenter)="mouseEnter(item)" (mouseleave)="mouseLeave(item)">
        <div class="card w-100 p-0 z-2 card-article h-100 d-flex flex-column" [ngClass]="item.is_hover ? 'shadow-blue': 'shadow'" style="border-radius: 24px; cursor: pointer;" (click)="navigateToBlogDetail(item)">
            <div class="w-100 z-1" style="height: 200px; background-size: cover; border-radius: 24px 24px 0 0; " [ngStyle]="{'background-image': 'url(' + item.titleImage + ')'}">
            </div>
            <div class="card-body p-4 d-flex flex-column flex-grow-1">
                <div class="web-left font-title" style="min-height: 50px;">
                    {{item.title}}
                </div>
                <div class="web-left mt-2 mb-4 font-description"><span>{{ item.content_substring }}</span></div>
                <div class="d-flex mt-auto" style="justify-content: space-between; align-items: center;">
                    <button [style.background-color]="'#dfdfef'" class="btn btn-primary py-1 mt-2 mx-2 categoriesButton1" *ngIf="item.hashtags!='null'">
                        {{item.hashtags}}
                    </button>
                    <button [style.background-color]="'#dfdfef'" class="btn btn-primary py-1 mt-2 mx-2 categoriesButton1" *ngIf="item.hashtags=='null'" style="visibility: hidden;">
                        Null
                    </button>
                    <span class="mt-2 font-read-more cursor-pointer" (click)="navigateToBlogDetail(item)">
                        Read more
                    </span>
                </div>
            </div>
        </div>
    </div>
</ng-template>